import { formatEuros } from '@garage/shared';

/**
 * Affiche un montant **uniquement s'il a été renvoyé par l'API**. Aucun calcul côté interface :
 * un montant absent (droit `amounts.view` manquant) ou vide (`null`, prix non saisi) n'affiche rien,
 * ou le texte `missing` s'il est fourni (jamais un chiffre).
 */
export function Money({
  value,
  suffix,
  missing,
  className,
}: {
  value: string | null | undefined;
  suffix?: string;
  missing?: string;
  className?: string;
}) {
  if (value === null || value === undefined || value === '') {
    return missing ? <span className={`text-ink-3 ${className ?? ''}`}>{missing}</span> : null;
  }
  return (
    <span className={`tabular-nums ${className ?? ''}`}>
      {formatEuros(value)}
      {suffix ? ` ${suffix}` : ''}
    </span>
  );
}

/** Vrai si l'API a renvoyé ce montant (permet de masquer un libellé « Total » orphelin). */
export function hasAmount(value: string | null | undefined): value is string {
  return value !== null && value !== undefined && value !== '';
}
